import { API_BASEURLICON } from "../../Config";
import { useEffect, useRef } from "react";

const Banner = () => {
  const imageUrl = API_BASEURLICON;

  const logoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("zoom-active");
          } else {
            entry.target.classList.remove("zoom-active");
          }
        });
      },
      { threshold: 0.5 },
    );

    if (logoRef.current) {
      observer.observe(logoRef.current);
    }

    return () => {
      if (logoRef.current) {
        observer.unobserve(logoRef.current);
      }
    };
  }, []);

  return (
    <>
      <section
        className="services-overview content-wrapper custom-content-wrapper with-bottom-padding spacing-with-header"
        id="services-overview"
      >
        <div className="services-container layoutId-1 single video-bg-section">
          {/* Background Video */}

          <video autoPlay muted loop playsInline className="background-video">
            <source
              src="https://www.mobikwik.com/assets/images/revampMBK/root_page/homepage-video-final.mp4"
              type="video/mp4"
            />
          </video>

          {/* Dark Overlay */}
          <div className="video-overlay"></div>

          {/* <div className="cus-animation-logo">
            <img
              src={`${imageUrl}Image/Website/1/B2C-whitelogo.png`}
              alt="Pocketvila Logo"
            />
          </div> */}

          <div className="service service-2 with-margin cus-main-service-1">
            <img
              className="cus-animation-logo"
              ref={logoRef}
              src={`${imageUrl}Image/Website/1/B2C-whitelogo.png`}
              alt="Pocketvila Logo"
            />

            <div className="cus-content-541">
              <div className="content">
                <div className="simple_secure simple_secure-2">
                  <h3 className="typewriter">
                    Fast, Simple and Secure way to pay
                  </h3>
                </div>

                <p className="sub-text sub-text-2">
                  Make payments in-store or online, plus send money to any bank
                  account in a flash directly from your bank account.
                </p>

                <ul className="service-features service-features">
                  <li className="typewriter-2">
                    Fastest QR scan for lightspeed payments
                  </li>
                  <li className="typewriter-2">100% safe &amp; secure</li>
                  <li className="typewriter-2">
                    24/7 money transfers to anyone, anytime
                  </li>
                </ul>

                <div className="btn-section">
                  <div className="download-icons qrcode">
                    <div className="qr-code-wrapper">
                      <img
                        src="assets/pwa-static/pwa/images/new_pocket_qr.webp"
                        style={{ height: "149px" }}
                        alt="QR"
                      />
                    </div>
                    <div>
                      <p className="qr-code-text">
                        Scan QR code to download app
                      </p>

                      <a
                        href="https://play.google.com/store/apps/details?id=com.solution.pocketvila&hl=en_IN"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://fcpress.freecharge.in/api/mediamanager/media/qKsU_pK09.svg"
                          alt="Play Store"
                          loading="lazy"
                        />
                      </a>

                      <a href="#" className="cus-playstore-mobile">
                        <img
                          src="https://fcpress.freecharge.in/api/mediamanager/media/2X7XqJs-f.svg"
                          alt="App Store"
                          loading="lazy"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cus-image-vector animaction-css-img">
                <img
                  src="assets/pwa-static/pwa/images/payment.webp"
                  alt="Payment"
                  className="zoom-scroll-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
